export function getWebsiteFromLocation(
  location: Location,
  production: boolean,
): string {
  const website: string = location.hostname.split('.')[0];

  if (!production && website === 'localhost') {
    return 'demo';
  }

  return website;
}
